exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_box_3yze7xlNVrMtBDKjmpBy-B {\n  height: 295px;\n  position: fixed;\n  background-color: #ffffff;\n  padding: 10px 20px 20px 20px;\n  border-radius: 5px;\n  box-sizing: border-box;\n  border: 1px solid #e7e7e7;\n  /* Below box shadow is the same as the other Froala popups */\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12); \n}", ""]);

// Exports
exports.locals = {
	"IA_box": "IA_box_3yze7xlNVrMtBDKjmpBy-B"
};